import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=5c2281af&scoped=true"
import script from "./CourseItem.vue?vue&type=script&lang=ts"
export * from "./CourseItem.vue?vue&type=script&lang=ts"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=5c2281af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2281af",
  null
  
)

export default component.exports